import { Typography } from 'antd';
import React from 'react';
import { t } from 'src/libs/i18n';

const Note: React.FC = () => {
  return (
    <div className="note">
      <Typography.Title level={4}>
        {t('customer_registration.note_1')}
      </Typography.Title>
      <Typography.Paragraph className="mt-10">
        {t('customer_registration.note_2')}
      </Typography.Paragraph>
      <Typography.Paragraph className="mt-10">
        {t('customer_registration.note_3')}
      </Typography.Paragraph>
    </div>
  );
};

export default Note;
